export const INITIATE_MAIN_LOOP = "INITIATE_MAIN_LOOP";
export const initiateMainLoop = () => ({
  type: INITIATE_MAIN_LOOP
});



// WEBPACK FOOTER //
// ./src/redux/actions/controllers/main.js